import Loading from "@/components/Loading";
import AdminLayout from "@/layout/AdminLayout";
import React from "react";
import {PAGE_URL} from "../services/constant";
const NotificationType = React.lazy(() =>
    import('../NotificationType')
);
const notificationTypeRoutesRegistry = [
    {
        path: PAGE_URL.NOTIFICATION_TYPE_PAGE,
        element: <NotificationType />,
        loading: <Loading />,
        layout: AdminLayout,
    },
];

export default notificationTypeRoutesRegistry;
